import { parseAsStringLiteral, useQueryState } from "nuqs";
import {
  ApiKeysPanel,
  LabelsPanel,
  ReposPanel,
  SlaPanel,
  StatusesPanel,
  TypesPanel,
  UsersPanel,
} from "../components/issues/settings-panels";
import { PageHeader } from "../components/page";
import { GeneralTab } from "../components/settings/general-tab";
import { Tabs } from "../components/ui/tabs";
import { ViewTab, ViewTabsList, ViewToolbar } from "../components/view-tabs";

const SETTINGS_TABS = [
  { value: "general", label: "General" },
  { value: "users", label: "Users" },
  { value: "repos", label: "Repos" },
  { value: "labels", label: "Labels" },
  { value: "types", label: "Issue types" },
  { value: "statuses", label: "Statuses" },
  { value: "sla", label: "SLA policies" },
  { value: "api-keys", label: "API keys" },
] as const;

const tabParam = parseAsStringLiteral(SETTINGS_TABS.map((entry) => entry.value)).withDefault("general");

export function SettingsPage() {
  const [tab, setTab] = useQueryState("tab", tabParam);
  return (
    <>
      <PageHeader title="Settings" description="Issues, users, repos, connections and the audit trail." />
      <ViewToolbar
        tabs={
          <Tabs value={tab} onValueChange={(value) => void setTab(value as typeof tab)}>
            <ViewTabsList className="flex-wrap">
              {SETTINGS_TABS.map((entry) => (
                <ViewTab key={entry.value} value={entry.value}>
                  {entry.label}
                </ViewTab>
              ))}
            </ViewTabsList>
          </Tabs>
        }
      />
      {tab === "general" && <GeneralTab />}
      {tab === "users" && <UsersPanel />}
      {tab === "repos" && <ReposPanel />}
      {tab === "labels" && <LabelsPanel />}
      {tab === "types" && <TypesPanel />}
      {tab === "statuses" && <StatusesPanel />}
      {tab === "sla" && <SlaPanel />}
      {tab === "api-keys" && <ApiKeysPanel />}
    </>
  );
}
